

export function Spinner() {
    return (
        <div style={{
            backgroundColor: 'rgba(20, 20, 20,0.95)',
            color: 'orange',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            placeItems: 'center',
            margin: 0,
            padding: 0,
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
        }}
        >
            <h1>Loading...</h1>
        </div>
    )

}

export default Spinner;
